module.exports = __webpack_public_path__ + "img/3price.df8c1f2f.png";